export default __webpack_public_path__ + "static/media/image1.265a944a.png";